import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

const baseLinkStyles = css`
  color: #054d80;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const LinkStyled = styled(Link)`
  ${baseLinkStyles}
`;

export const AStyled = styled.a`
  ${baseLinkStyles}
`;

export const LinkStyledButton = styled.button`
  background-color: unset;
  border: none;
  padding: 0;
  ${baseLinkStyles}
`;

export const AnchorLink = styled.a`
  ${baseLinkStyles}
`;

export default LinkStyled;
